import { useEffect } from 'react'

export function useScrollTop (): void {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
}
